import { memo } from 'react';

import { RefreshCcwIcon } from '@air/design-icons';

export const VideoVisualizerProcessingBanner = memo(() => {
  return (
    <div className="flex w-full justify-center pb-2">
      <div className="flex items-center gap-1 rounded-8 ads:bg-ads-gray-4 bg-gray-4 px-3 py-2.5">
        <RefreshCcwIcon size="sm" className="animate-spin ads:text-icon-default text-gray-11" />
        <div className="ads:text-primary text-12 text-gray-12">
          This video is still processing. You may experience delayed playback.
        </div>
      </div>
    </div>
  );
});

VideoVisualizerProcessingBanner.displayName = 'VideoVisualizerProcessingBanner';
